module.exports = __webpack_public_path__ + "images/collaborate-usp_e4c4fc6b12ad52875844041f4817f344.jpg";